module.exports = __webpack_public_path__ + "static/img/page.01d8ba73.png";